function _(n,t,e){var o=n(44),r=n(48),f=n(70),i=n(84),u=n(66),c=n(24).iterator;t.exports=function(n){return"function"==typeof u(n)[c]?n[c]():o(n)?new f(n):r(n)?new i(n):new f(n)}}
//# sourceMappingURL=get.min.js.map